import {
    HttpResponse,
    ImportModel,
    RequestParams,
    ApiResultFailed,
    Operation,
    AggregationModel,
    AggregationResponse,
    GrouppedQueryModel
} from "@/libs/Api";
import ApiService from "@/libs/core/api-service"
import {CrudDataQuery, CrudService} from '@/libs/core/+state/models/crud-service';
import {CrudEnumerableResponse, CrudResponse} from "../core/+state/models/crud-response";

export class ImportsDataService implements CrudService<ImportModel, ImportModel> {

    getBasicAll(query: CrudDataQuery<ImportModel>): Promise<CrudEnumerableResponse<ImportModel>> {
        throw new Error("Method not implemented.");
    }

    clone(item: ImportModel, params?: RequestParams): Promise<CrudResponse<ImportModel>> {
        throw new Error("Method not implemented.");
    }

    getGroupped(query: GrouppedQueryModel, params?: RequestParams): Promise<CrudResponse<any>> {
        throw new Error("Method not implemented.");
    }

    getAll(query: CrudDataQuery<ImportModel>): Promise<CrudEnumerableResponse<ImportModel>> {
        return ApiService.api.getImportBatch(query.pageIndex, query.pageSize, <any>query.data, query.params);
    }

    get(id: string, params?: RequestParams): Promise<CrudResponse<ImportModel>> {
        return ApiService.api.getImportById(id, params);
    }

    create(item: ImportModel, params?: RequestParams): Promise<CrudResponse<ImportModel>> {
        return ApiService.api.insertImport(item, params);
    }

    update(item: ImportModel, params?: RequestParams): Promise<ImportModel> {
        return ApiService.api.updateImport(item.id as Required<string>, item, params).then((req: any) => req.data.returnValue);
    }

    partialUpdate(id: string, patches: Operation[], params?: RequestParams): Promise<ImportModel> {
        return ApiService.api.patchImport(id, patches).then((req: any) => req.data.returnValue);
    }

    delete(query: CrudDataQuery<ImportModel>): Promise<CrudEnumerableResponse<ImportModel>> {
        return ApiService.api.deleteImports(<any>query.data, query.params).then((req: any) => req.data.returnValue);
    }

    getAggregation(query: AggregationModel): Promise<AggregationResponse> {
        return ApiService.api.aggregationImport(query).then((req: any) => req.data.returnValue);
    }
    
    download(query: CrudDataQuery<ImportModel>): Promise<HttpResponse<any, ApiResultFailed | void>> {
        throw new Error('NotImplemented');
    }

    print(id: string, params?: RequestParams): Promise<HttpResponse<any, ApiResultFailed | void>> {
        throw new Error('NotImplemented');
    }

}
